const $ = jQuery;

export default () => {
	$(window).on('load', () => {
		setTimeout(() => {
			// Function to get computed style
			const getComputedStyle = (element, pseudo) => window.getComputedStyle(element, pseudo);

			// Function to modify content
			const modifyContent = (content) => {
				// Check if the content is empty, "0", or just whitespace
				const trimmedContent = content.replace(/^["']|["']$/g, '');
				if (!trimmedContent || trimmedContent === '0' || /^\s*$/.test(trimmedContent)) {
					return content; // Return original content without modification
				}
				if (content && content !== '"0"' && content !== "'0'") {
					return `${content}/" " `;
				}
				return content;
			};

			// Create a style element
			const style = document.createElement('style');
			let styleContent = '';

			// Process each menu item for both :before and :after
			$('.et-menu .menu-item-has-children > a:first-child, .nav .menu-item-has-children > a:first-child').each((index, element) => {
				['before', 'after'].forEach((pseudo) => {
					const computedStyle = getComputedStyle(element, `:${pseudo}`);
					const content = computedStyle.getPropertyValue('content');
					const modifiedContent = modifyContent(content);
					if (content !== modifiedContent) {
						styleContent += `
                .et-menu .menu-item-has-children > a:first-child:nth-of-type(${index + 1}):${pseudo},
                .nav .menu-item-has-children > a:first-child:nth-of-type(${index + 1}):${pseudo} {
                    content: ${modifiedContent} !important;
                }
            `;
					}
				});
			});// Set the style content and append to head
			style.textContent = styleContent;
			document.head.appendChild(style);
		}, 2000);
	});
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/prevent-header-nav-menu-arrow-icons-screen-reader.js